import SPC from "components/Stacker/constants/SearchPageConstants"
import SC from "../constants/StackerConstants"

export const initialState = {
  maxItems: 10,
  products: [],
  productInfo: { title: "", description: { __html: "" }, pid: "", url: "" },
  status: "None",
  search: {
    fq: "",
    pageNumber: 0,
    pageSize: 40,
    q: "",
    requestType: "search",
    search: "true",
    searchType: "category",
    sort: "low_price asc",
  },
}

export default function braceletStackerReducer(
  previousState = initialState,
  action
) {
  switch (action.type) {
    case SC.SHOW_PRODUCT_INFO:
      return { ...previousState, productInfo: action.payload }
    case SC.PRODUCTS_NEXT_PAGE:
      return {
        ...previousState,
        search: {
          ...previousState.search,
          pageNumber: previousState.search.pageNumber + 1,
        },
      }
    case SPC.SEARCH_FILTER_APPLY_CLICKED:
      return {
        ...previousState,
        search: {
          ...previousState.search,
          pageNumber: 0,
        },
      }
    default:
      return previousState
  }
}
